/** User-facing article URL under the blog section. */
export const caseStudyBlogPath = (slug: string) => `/blog/${slug}`

/** Legacy / direct URL (also used as canonical when the same page is served at `/blog/:slug`). */
export const caseStudyCanonicalPath = (slug: string) => `/case-studies/${slug}`

/** Extract slug from stored `read_also` URLs (either prefix). */
export const caseStudySlugFromListUrl = (url: string): string | undefined => {
  const caseStudyMatch = url.match(/\/case-studies\/([^/?#]+)/)
  if (caseStudyMatch?.[1]) {
    return caseStudyMatch[1]
  }
  const blogMatch = url.match(/\/blog\/([^/?#]+)/)
  return blogMatch?.[1]
}
